/**
 * DiaryPlayer — 日記卡上面嘅**迷你播放器**（綁全 app 播放器）
 *
 * 血緣：`decisions/027`（產品負責人：「then below is the lyrics and the player that can play the song」）
 * 由 `components/DiaryCard.tsx` 拆出（`P-90`：每個檔 ≤200 行）
 *
 * ⚠️ **一個 app 只有一個播放器**（`PlayerContext`）—— 呢度只係「入口」，唔會自己整 `<audio>`
 * ⚠️ 未有音頻 → **照實講**（`diary_no_audio`；唔准靜靜唔動）
 */
import { useTranslation } from 'react-i18next';
import AudioPlayer from '@coeldery/audio-player';
import type { LibrarySong } from '../hooks/useLibrary';
import { trackFromSong, type Track } from '../player/playerModel';
import { usePlayer } from '../player/PlayerContext';

export interface DiaryPlayerProps {
  song: LibrarySong;
  /** 順播 queue（同畫面次序一致）；撳播放時用 */
  queue: Track[];
  deviceId: string | null;
}

export default function DiaryPlayer({ song, queue, deviceId }: DiaryPlayerProps) {
  const { t } = useTranslation();
  const player = usePlayer();
  const isCurrent = player.track?.id === song.id;

  if (!song.audioKey) return <p className="footnote">{t('diary_no_audio')}</p>;

  return (
    <AudioPlayer
      variant="mini"
      title={song.title}
      playing={isCurrent && player.playing}
      positionMs={isCurrent ? player.positionMs : 0}
      durationMs={isCurrent ? player.durationMs : null}
      error={isCurrent ? player.error : null}
      onToggle={() => {
        /** 已經係呢首 → 只係暫停／繼續；否則用**畫面次序**做 queue 開始播 */
        if (isCurrent) {
          player.toggle();
          return;
        }
        const track = trackFromSong(song, { deviceId });
        if (track) player.play(track, queue);
      }}
    />
  );
}
